import React from 'react';
import styles from '../../albumSeeAll/AlbumSeeAll.module.css';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router';

const MusicAlbumSeeAllLoading = () => {
  const navigate = useNavigate();
  const skeletonStyles = {
    backgroundColor: 'white',
    color: 'white', // Set the text color to white
  };

//   const handleAlbumClick = (albumId) => {
//     navigate(`/music/detail/album/${albumId}`);
//   };

  const skeletonItems = Array.from({ length: 15 }, (_, index) => (
    <div key={index} className="truncate inline-block text-center">
      <Skeleton
        variant="rectangular"
        className="rounded-lg"
        width={150}
        height={150}
        sx={{ ...skeletonStyles }}
        // onClick={() => handleAlbumClick(index)}
      />
      <Skeleton
        variant="text"
        className=" mt-2"
        width={80}
        height={25}
        sx={{ ...skeletonStyles,
            marginX: "auto"
         }}
      />
    </div>
  ));

  return (
    <div className={`${styles.grid_cols_custom} grid`}>
      {skeletonItems}
    </div>
  );
};

export default MusicAlbumSeeAllLoading;
